import { render, staticRenderFns } from "./ToTop.vue?vue&type=template&id=3a43670d&"
import script from "./ToTop.vue?vue&type=script&lang=ts&"
export * from "./ToTop.vue?vue&type=script&lang=ts&"
import style0 from "./ToTop.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports